import ValueExpression from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';
import { getDefinitionByName } from '@legacy-modules/common/util/kpiDefinitions';
import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';

import { ChartType } from '@legacy-modules/metrics2/models/enumerations/ChartType';

export default new ValueExpression({
  identifier: 'tourdauer_rueckfahrt',
  label: 'Rückfahrtzeit',
  valueFormat: '-#.###.##0,0 h',
  chart: ChartType.bar,
  positiveDirection: PositiveDirection.down,
  category: 'tours',
  description: '',
  hidden: true,
  definition: getDefinitionByName('Rückfahrtzeit'),
  valueQuotient: 3600,
});
